<div fxFlex=100 class="premiereImageDiv" fxLayout="row wrap">
        
        
    <div  class="backButton" fxLayout="row">
            <img (click)="back()" style="cursor: pointer;" src="assets/images/cinejoy/arrow-left.png" alt="">
    </div>

    <div class="more_info_web_cart">
        <app-shopping-cart ></app-shopping-cart>
    </div>

    
    <div fxLayout="row" class="premiereMainImage">
        <img class="event-image-width" fxFlex=80.3 fxFlex.md=80.3 fxFlex.gt-lg=80.3 [src]="eventImage" alt="">
    </div>
    
                        
    <div  class="cinequestLogo" fxLayout="row">
        <img fxFlex="20"  src="assets/images/spotlight/Laurel.svg"/>
    </div>                                   
    
</div>


